import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import UpdateLicenseForm from "../../forms/UpdateLicenseForm";

const UpdateLicenseModal = ({ open, onClose, license, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Edit license.`}
      width="md"
      loading={loading}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <UpdateLicenseForm license={license} loading={loading} />
    </AppModal>
  );
};

export default UpdateLicenseModal;
